function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M18.6548 6.21059C19.0908 6.54958 19.1695 7.17784 18.8305 7.61385L11.0555 17.6138C10.8824 17.8365 10.6232 17.9758 10.342 17.9972C10.0607 18.0186 9.78344 17.9202 9.57859 17.7262L5.35352 13.7262C4.95246 13.3465 4.93514 12.7136 5.31483 12.3126C5.69453 11.9115 6.32746 11.8942 6.72852 12.2739L10.1532 15.5161L17.2515 6.38625C17.5905 5.95024 18.2188 5.87159 18.6548 6.21059Z",
  fill: "#B69D73"
});

function SvgCheckIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref);
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckIcon);
export default __webpack_public_path__ + "static/media/check-icon.4c3559a7.svg";
export { ForwardRef as ReactComponent };